import arrowUpGreen from '../../../../_metronic/assets/images/svg/data-room/arrow-up-green.svg'
import { useIntl } from 'react-intl'
import { StatisticsWidgetDataRoom } from './StatisticsWidgetDataRoom'
import arrowDownRed from '../../../../_metronic/assets/images/svg/data-room/arrow-down-red.svg'
function OverviewStats({ statisticsDataRoom, statisticsDataRoomTimeSpent }: any) {
  const { formatMessage } = useIntl()
  function formatTime(seconds: number) {
    const days = Math.floor(seconds / 86400)
    const hours = Math.floor((seconds % 86400) / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    const remainingSeconds = seconds % 60

    if (days > 0) {
      return `${days}d ${hours}h ${minutes}m`
    } else if (hours > 0) {
      return `${hours}h ${minutes}m ${remainingSeconds}s`
    } else if (minutes > 0) {
      return `${minutes}m ${remainingSeconds}s`
    } else {
      return `${remainingSeconds}s`
    }
  }

  return (
    <div className='data-rooms-stats-grid d-flex flex-md-row flex-column'>
      <div className='bg-white stats-card-wrapper rounded w-100'>
        <div className='stats-card-top'>
          <p className='mb-0 stats-card-heading'>{formatMessage({ id: 'Total Visits' })}</p>
          <div className='d-flex flex-row align-items-center'>
            <h1 className='mb-0 dark_text_color'>
              {statisticsDataRoom?.thisWeekTotalVisits || '-'}
            </h1>
            <p
              className={`mb-0 d-flex flex-row align-items-center stats-percent ${statisticsDataRoom?.percentage_Difference < 0 ? 'text-danger' : 'text-success'
                }`}
            >
              <img
                src={statisticsDataRoom?.percentage_Difference < 0 ? arrowDownRed : arrowUpGreen}
                alt=''
              ></img>
              {(statisticsDataRoom?.percentage_Difference ||
                statisticsDataRoom?.percentage_Difference === 0) &&
                (statisticsDataRoom?.percentage_Difference === 'Infinity' ? (
                  <span className='fs-1'>&infin;</span>
                ) : isNaN(statisticsDataRoom?.percentage_Difference) ? (
                  '0'
                ) : (
                  Math.abs(statisticsDataRoom?.percentage_Difference).toFixed()
                ))}
              %
            </p>
          </div>
        </div>

        <StatisticsWidgetDataRoom
          statisticsData={statisticsDataRoom?.selectedWeek}
          className='card-xl-stretch '
          color='primary'
          label='Total Visits'
        />
      </div>
      <div className='bg-white stats-card-wrapper rounded w-100'>
        <div className='stats-card-top'>
          <p className='mb-0 stats-card-heading'>{formatMessage({ id: 'Total Time Spent' })}</p>
          <div className='d-flex flex-row align-items-center'>
            <h1 className='mb-0 dark_text_color'>
              {statisticsDataRoomTimeSpent?.thisWeekTotalTime
                ? formatTime(statisticsDataRoomTimeSpent?.thisWeekTotalTime)
                : '-'}
            </h1>
            <p
              className={`mb-0 d-flex flex-row align-items-center stats-percent ${statisticsDataRoom?.percentage_Difference < 0 ? 'text-danger' : 'text-success'
                }`}
            >
              <img
                src={
                  statisticsDataRoomTimeSpent?.percentage_Difference < 0
                    ? arrowDownRed
                    : arrowUpGreen
                }
                alt=''
              ></img>
              {(statisticsDataRoom?.percentage_Difference ||
                statisticsDataRoom?.percentage_Difference === 0) &&
                (statisticsDataRoom?.percentage_Difference === 'Infinity' ? (
                  <span className='fs-1'>&infin;</span>
                ) : isNaN(statisticsDataRoomTimeSpent?.percentage_Difference) ? (
                  '0'
                ) : (
                  Math.abs(statisticsDataRoomTimeSpent?.percentage_Difference).toFixed()
                ))}
              %
            </p>
          </div>
        </div>
        <StatisticsWidgetDataRoom
          statisticsData={statisticsDataRoomTimeSpent?.selectedWeek}
          className='card-xl-stretch'
          color='primary'
          label='Total Time Spent'
        />
      </div>
    </div>
  )
}

export default OverviewStats
